import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output
} from '@angular/core';


export class SkyTokenComponent {
  
  public set disabled(value: boolean) {
    this._disabled = value;
  }

  public get disabled(): boolean {
    return (this._disabled === true);
  }

  
  public set dismissible(value: boolean) {
    this._dismissible = value;
  }

  public get dismissible(): boolean {
    return (this._dismissible !== false);
  }

  
  public set focusable(value: boolean) {
    this._focusable = value;
  }

  public get focusable(): boolean {
    return (this._focusable !== false);
  }

  
  public dismiss = new EventEmitter<void>();

  
  public tokenFocus = new EventEmitter<void>();

  public get tabIndex(): number | boolean {
    return (this.focusable) ? 0 : -1;
  }

  private _disabled: boolean;
  private _dismissible: boolean;
  private _focusable: boolean;

  constructor(
    private elementRef: ElementRef
  ) { }

  public dismissToken() {
    this.dismiss.emit();
  }

  public focusElement() {
    this.elementRef.nativeElement.querySelector('.sky-token').focus();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-token',
  template: `<div
  class="sky-token sky-btn sky-btn-default"
  role="button"
  [attr.tabindex]="tabIndex"
  [ngClass]="{ 'sky-btn-disabled': disabled }"
  [attr.aria-disabled]="disabled"
  (focus)="tokenFocus.emit()">

  <ng-content>
  </ng-content>

  <button
    *ngIf="dismissible"
    type="button"
    class="sky-btn sky-token-btn-close"
    [attr.tabindex]="tabIndex"
    [attr.title]="'token_dismiss_button_title' | skyResources"
    [disabled]="disabled"
    (click)="dismissToken();$event.stopPropagation();">
    <i
      class="fa fa-times"
      aria-hidden="true"></i>
  </button>
</div>
`,
  styles: [`.sky-token {
  background-color: #c1e8fb;
  border: 1px solid #00b4f1;
  padding: 2px 8px;
  display: inline-block;
  user-select: none;
}

.sky-token:hover, .sky-token:focus {
  background-color: #91d6f8;
  border-color: #008ebe;
  cursor: pointer;
}

.sky-token:focus {
  box-shadow: 0 0 8px rgba(0, 180, 241, 0.6);
  border: 1px solid #00b4f1;
  outline: none;
}

.sky-btn-disabled {
  cursor: default;
  user-select: none;
}

.sky-token-btn-close {
  background: transparent;
  padding: 0;
  border: 0;
  margin-left: 2px;
  opacity: .9;
}

.sky-token-btn-close:hover, .sky-token-btn-close:focus {
  opacity: 1;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'disabled': [{ type: Input },],
'dismissible': [{ type: Input },],
'focusable': [{ type: Input },],
'dismiss': [{ type: Output },],
'tokenFocus': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
